export default {
    login: 'تسجيل دخول'
}